<template>
    <div :key="currentM3CompanyCui">
        <validation-observer #default="{ invalid }" ref="observer">
            <span class="display-none">{{ invalid }}</span>
            <b-form ref="formular">
                <div class="white-box mt-3">
                    <div class="data-group">
                        <M3FormTitle title="Codul CAEN eligibil" :checked="completed"></M3FormTitle>
                        <div class="flex space-between position-relative">
                            <validation-provider
                                #default="{ errors }"
                                rules="required|digits:4"
                                class="first-input"
                                name="cod CAEN"
                            >
                                <b-form-group
                                    id="fieldset-horizontal"
                                    label-cols-lg="6"
                                    content-cols-lg="6"
                                    label-cols-md="3"
                                    content-cols-md="3"
                                    label="Cod CAEN principal"
                                    class="has-icon"
                                >
                                    <b-form-input
                                        id="name"
                                        v-model="form.caen"
                                        type="text"
                                        name="message"
                                        :state="errors.length > 0 ? false : null"
                                        :readonly="form.caen_saved"
                                        @keyup="getCaenName(form.caen); caenEligibil(true)"
                                    ></b-form-input>
                                    <img src="@/assets/images/M3/M3Sketch/edit.png" class="title-icon">
                                </b-form-group>
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                            <b-form-input
                                v-model="caenName"
                                type="text"
                                name="message"
                                readonly
                                class="caen-name-input"
                                style="text-transform: inherit;"
                            ></b-form-input>
                            <div v-if="eligibil === 'eligibil'"
                                 class="points"
                                 :class="[eligibil === 'eligibil' ? 'check' : 'deny']"
                            >
                                5 puncte
                            </div>
                            <div v-if="eligibil === 'gri'" class="points gri">
                                0 puncte
                            </div>
                            <div v-else-if="eligibil === 'neeligibil'" class="points deny">
                                Neeligibil
                            </div>
                            <div class="checkmarks">
                                <b-icon-check-circle-fill v-if="eligibil === 'eligibil' || eligibil === 'gri'" font-scale="1.7" class="check"></b-icon-check-circle-fill>
                                <b-icon-x-circle-fill v-else font-scale="1.7" class="deny"></b-icon-x-circle-fill>
                            </div>
                        </div>
                        <div class="flex caen-input space-between mt-2 mb-4" @click="changeCaen()">
                            <b-form-radio-group v-model="proiect_vizat" :options="options" :class="form.caen_saved ?'disabled-radio':''" name="radio-validation" class="mt-2 mb-2"></b-form-radio-group>
                        </div>
                        <div v-if="proiect_vizat === '2'" class="flex space-between position-relative">
                            <validation-provider
                                #default="{ errors }"
                                rules="required|digits:4"
                                class="first-input"
                                name="cod CAEN"
                            >
                                <b-form-group
                                    id="fieldset-horizontal"
                                    label-cols-lg="6"
                                    content-cols-lg="6"
                                    label="Cod CAEN secundar"
                                    class="min-width"
                                >
                                    <v-select
                                        v-model="form.secondary_caen"
                                        :close-on-select="true"
                                        :options="secundare"
                                        :taggable="true"
                                        :state="errors.length > 0 ? false : null"
                                        :class="form.caen_saved ?'disabled-select':''"
                                        @input="getSecondaryCaenName(form.secondary_caen); caenEligibil()"
                                    ></v-select>
                                </b-form-group>
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                            <b-form-input
                                :v-model="getSecondaryCaenName(form.secondary_caen)"
                                :value="getSecondaryCaenName(form.secondary_caen)"
                                type="text"
                                name="message"
                                readonly
                                style="text-transform: inherit;"
                                :style="[secundarEligibil === 'eligibil' || secundarEligibil === 'gri' ? {'width': '47%'} : {'width': '63%'}]"
                            ></b-form-input>
                            <div v-if="secundarEligibil === 'eligibil'" class="points check">
                                5 puncte
                            </div>
                            <div v-if="secundarEligibil === 'gri'" class="points gri">
                                0 puncte
                            </div>
                            <div class="checkmarks">
                                <b-icon-check-circle-fill v-if="secundarEligibil === 'eligibil' || secundarEligibil === 'gri'" font-scale="1.7" class="check"></b-icon-check-circle-fill>
                                <b-icon-x-circle-fill v-else font-scale="1.7" class="deny"></b-icon-x-circle-fill>
                            </div>
                        </div>

                        <M3Warn
                            type="yellow"
                            :text="'<strong>ATENȚIE!</strong> Ghidul solicitantului prevede: Beneficiarii sunt IMM-urile din România active în sectoarele eligibile.\n'+
                                'Astfel, există posibilitatea ca în ghidul final să existe prevederi suplimentare cu privire la obligativitatea autorizării acestor coduri CAEN. Experții Smis recomandă aplicarea pentru o activitate aferentă unui cod CAEN autorizat. Codurile CAEN autorizate se regăsesc in extrasul (certificat constatator) eliberat prin ONRC.\n'"
                        ></M3Warn>
                        <M3Warn
                            type="blue"
                            :text="'<strong>ATENȚIE!</strong> Ghidul solicitantului prevede: Solicitantul nu a mai beneficiat de sprijin financiar din fonduri publice, inclusiv fonduri UE, în ultimii 5 ani, sau nu derulează proiecte finanțate în prezent, parțial sau în totalitate, din alte surse publice, pentru aceleași activități.'"
                            class="mb-4"
                        ></M3Warn>

                        <hr class="mt-5">
                        <b-form-checkbox
                            v-model="completed"
                            switch
                            size="lg"
                            class="switch-box mt-3"
                            @change="completeForm()"
                        >Informațiile sunt complete și corecte</b-form-checkbox>
                        <div class="warn mt-4 mb-4">
                            <p>ATENȚIE!</p>
                            <p>Vă rugăm să acordați o atenție sporită alegeri codului CAEN. Aplicația vă permite să optați pentru un cod CAEN eligibil (autorizat/neautorizat).
                                Verificați cu atenție punctajul obținut și legați cheltuielile exclusiv de codul CAEN pentru care se aplică.</p>
                        </div>
                    </div>
                    <img src="@/assets/images/M3/M3Sketch/termenesmall.png" class="termene-icon">
                </div>
            </b-form>
        </validation-observer>
    </div>
</template>

<script>
    import { BForm, BFormInput, BFormGroup, BButton, BFormCheckbox, BIconCheckCircleFill, BIconXCircleFill, BFormRadioGroup } from 'bootstrap-vue'
    import { ValidationProvider, ValidationObserver } from 'vee-validate'
    import vSelect from 'vue-select'
    import listaCaen from '@/pages/Aplicatii/M3/caen_eligibil.json';
    import M3FormTitle from '../M3FormTitle'
    import caen from '@/pages/Aplicatii/M3/M3Sketch/caen'
    import _ from "lodash";
    import Vue from 'vue';
    import M3Warn from '@/pages/Aplicatii/M3/M3Sketch/components/M3Warn'
    import VueSweetalert2 from 'vue-sweetalert2';
    Vue.use(VueSweetalert2);
    require('@/helpers/validations/validations')
    export default {
        components: {
            BForm,
            BFormInput,
            BFormGroup,
            BButton,
            BFormCheckbox,
            M3FormTitle,
            BIconCheckCircleFill,
            BIconXCircleFill,
            BFormRadioGroup,
            ValidationProvider,
            ValidationObserver,
            vSelect,
            VueSweetalert2,
            M3Warn
        },
        props: {
            caen: null,
            caenProps: null,
        },
        data() {
            return {
                currentM3CompanyCui: JSON.parse(localStorage.getItem('currentM3Company')) ? JSON.parse(localStorage.getItem('currentM3Company')).id : null,
                form: {
                    caen: '',
                    secondary_caen: '',
                    caen_saved: false,
                },
                proiect_vizat: '',
                completed: false,
                caenName: '',
                secondary_caenName: null,
                options: [
                    { text: 'Proiectul vizează codul CAEN principal', value: '1' },
                    { text: 'Proiectul vizează un cod CAEN secundar eligibil  (vă rugăm selectați din lista de mai jos un cod CAEN eligibil)', value: '2' },
                ],
                caens: caen,
                data: null,
                secundare: [],
                eligibil: null,
                secundarEligibil: null,
            }
        },
        computed: {
            checks() {
                return this.$store.getters['checks/checks'];
            }
        },
        watch:{
            currentM3CompanyCui: {
                handler: function() {
                    this.data = this.caenProps
                    this.secCaenEligibil()
                    this.caenEligibil()
                },
                deep: false
            },
            caenProps: {
                handler: function() {
                    this.data = this.caenProps
                    this.secCaenEligibil()
                    this.caenEligibil()
                },
                deep: false
            },
            caen: {
                handler: function() {
                    this.form.caen = this.caen.caen
                    this.form.secondary_caen = this.caen.secondary_caen
                    this.form.caen_saved = this.caen.caen_saved
                    if(this.form.caen !== null){
                        this.getCaenName(this.form.caen)
                        this.caenEligibil(true)
                    }
                    if(this.form.secondary_caen !== null){
                        this.proiect_vizat = '2'
                        this.getSecondaryCaenName()
                        this.caenEligibil()
                    }
                },
                deep: false
            },
            checks: {
                handler: function() {
                    this.completed = this.checks.proiectulMeuCaenEligibil;
                    if(this.completed)
                        this.$emit('formComplete')
                    else
                        this.$emit('formIncomplete')
                },
                deep: true,
                immediate: true
            }
        },
        mounted() {
            this.form.caen = this.caen.caen
            this.form.secondary_caen = this.caen.secondary_caen
            this.form.caen_saved = this.completed
			if(this.caen.secondary_caen){
				this.proiect_vizat = '2'
			} else {
				this.proiect_vizat = '1'
			}
            this.getCaenName(this.form.caen)
            this.caenEligibil(true)
            /*this.secCaenEligibil()*/
        },

        methods: {

            changeCaen() {
                if(this.form.caen_saved){
                    this.$toast.error('Anulează salvarea formularului înainte de a modifica.')
                }
            },
            completeForm() {
                this.form.caen_saved = this.completed
                this.caenEligibil()
                if(this.completed) {
                    if(this.proiect_vizat == '1') {
                        this.form.secondary_caen = null
                        this.secondary_caenName = ''
                    }

                    if(this.eligibil === 'neeligibil' && this.proiect_vizat === '1'){
                        this.$swal({
                            title: 'Codul CAEN este neeligibil.<br>Ești sigur că vrei să continui?',
                            icon: 'warning',
                            confirmButtonText: 'Salvează',
                            showDenyButton: true,
                            denyButtonText: 'Anulează'
                        }).then((result) => {
                            if (result.isConfirmed) {
                                this.form.caen_saved = true
                                this.$refs.observer.validate().then((e) => {
                                    if(!e) {
                                        this.form.caen_saved = false
                                        this.$toast.error('Te rugăm completează câmpurile marcate cu roșu.');
                                    } else{
                                        this.form.caen_saved = true
                                        this.$store.dispatch('m3Sketch/saveAllDataProjectPart', this.form)
                                            .then((response) => {
                                                this.$store.dispatch('m3Sketch/initializeIndicators');
                                                this.$store.dispatch('checks/updateChecks', { name: 'proiectulMeuCaenEligibil', value: this.completed })
                                                this.$toast.success(response.data)
                                                this.$emit('formComplete')
                                            }).catch((xhr) => {
                                                if (xhr.status === 422) {
                                                    this.errors.record(xhr.responseJSON.errors);
                                                }
                                                this.$toast.error(xhr.response.data.message);
                                            });
                                    }
                                })
                            } else{
                                this.completed = false;
                                this.form.caen_saved = false
                            }
                        })
                    } else if((this.eligibil === 'gri' && this.proiect_vizat === '1') || (this.secundarEligibil === 'gri' && this.proiect_vizat === '2')) {
                        this.completed = false
                        this.$swal({
                            title: 'Folosind acest CAEN vei pierde 5 puncte.<br>Ești sigur că vrei să continui?',
                            icon: 'info',
                            confirmButtonText: 'Salvează',
                            showDenyButton: true,
                            denyButtonText: 'Anulează'
                        }).then((result) => {
                            if (result.isConfirmed) {
                                this.form.caen_saved = true
                                this.$refs.observer.validate().then((e) => {
                                    if(!e) {
                                        this.form.caen_saved = false
                                        this.$toast.error('Te rugăm completează câmpurile marcate cu roșu.');
                                    } else{
                                        this.form.caen_saved = true
                                        this.completed = true
                                        this.$store.dispatch('m3Sketch/saveAllDataProjectPart', this.form)
                                            .then((response) => {
                                                this.$store.dispatch('m3Sketch/initializeIndicators');
                                                this.$store.dispatch('checks/updateChecks', { name: 'proiectulMeuCaenEligibil', value: this.completed })
                                                this.$toast.success(response.data)
                                                this.$emit('formComplete')
                                            }).catch((xhr) => {
                                                if (xhr.status === 422) {
                                                    this.errors.record(xhr.responseJSON.errors);
                                                }
                                                this.$toast.error(xhr.response.data.message);
                                            });
                                    }
                                })
                            } else{
                                this.completed = false;
                                this.form.caen_saved = false
                            }
                        })
                    } else{
                        this.$refs.observer.validate().then((e) => {
                            if(!e) {
                                this.form.caen_saved = false
                                this.$toast.error('Te rugăm completează câmpurile marcate cu roșu.');
                            } else{
                                this.form.caen_saved = true
                                this.$store.dispatch('m3Sketch/saveAllDataProjectPart', this.form)
                                    .then((response) => {
                                        this.$store.dispatch('m3Sketch/initializeIndicators');
                                        this.$store.dispatch('checks/updateChecks', { name: 'proiectulMeuCaenEligibil', value: this.completed })
                                        this.$toast.success(response.data)
                                        this.$emit('formComplete')
                                    }).catch((xhr) => {
                                        if (xhr.status === 422) {
                                            this.errors.record(xhr.responseJSON.errors);
                                        }
                                        this.$toast.error(xhr.response.data.message);
                                    });
                            }

                        })
                    }

                } else{
                    this.form.caen_saved = false
                    this.$store.dispatch('m3Sketch/saveAllDataProjectPart', this.form)
                        .then((response) => {
                            this.$store.dispatch('m3Sketch/initializeIndicators');
                            this.$store.dispatch('checks/updateChecks', { name: 'proiectulMeuCaenEligibil', value: this.completed })
                            this.$toast.success(response.data)
                        }).catch((xhr) => {
                            if (xhr.status === 422) {
                                this.errors.record(xhr.responseJSON.errors);
                            }
                            this.$toast.error(xhr.response.data.message);
                        });

                }
            },
            getCaenName(event) {
                if (this.caens[event]) {
                    this.caenName = this.caens[event]
                } else{
                    this.caenName = ''
                }
            },
            getSecondaryCaenName(event) {
                if (this.caens[event]) {
                    this.secondary_caenName = this.caens[event]
                } else{
                    this.secondary_caenName = ''
                }
                return this.secondary_caenName
            },
            caenEligibil(isMain) {
                let eligibil
                if(isMain){
                    eligibil = _.filter(listaCaen, v => v.caen === this.form.caen)
                } else{
                    eligibil = _.filter(listaCaen, v => v.caen === this.form.secondary_caen)
                }

                if(isMain){
                    if (eligibil.length === 0) {
                        // Rosu
                        this.eligibil = 'neeligibil'
                    } else if (eligibil[0].eligibil === "negativ") {
                        // Verde
                        this.eligibil = 'eligibil'
                    } else if(eligibil[0].eligibil === 'pozitiv' || eligibil[0].eligibil === "necunoscut") {
                        this.eligibil = 'gri'
                    }
                } else{
                    if (eligibil.length === 0) {
                        // Rosu
                        this.secundarEligibil = 'neeligibil'
                    } else if (eligibil[0].eligibil === "negativ") {
                        // Verde
                        this.secundarEligibil = 'eligibil'
                    } else if(eligibil[0].eligibil === 'pozitiv' || eligibil[0].eligibil === "necunoscut") {
                        this.secundarEligibil = 'gri'
                    }
                }

            },
            secCaenEligibil() {
                let caenSecundare = _.map(this.data.coduriCaenSecundare, 'cod_caen_secundar')
                let find = _.filter(listaCaen, function(obj) {
                    if(caenSecundare.includes(obj.caen)){
                        return obj.caen;
                    }
                })
                let returnOnlyCaen = _.map(find, 'caen')
                this.secundare = returnOnlyCaen
            },
        }
    }
</script>

<style scoped>
.text-danger{
    width: 100%;
    white-space: pre;
}
.flex{
    display: flex;
}
.flex-end{
    justify-content: flex-end;
}
.space-between{
    justify-content: space-between;
}
.disabled-radio{
    pointer-events: none;
}
.white-box{
    background: #fff;
    padding: 20px;
    position: relative;
}
.data-group{
    margin: auto;
    width: 85%;
}
.disabled-select{
    background: #a1fff1 url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'%3e%3cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e") no-repeat right 0.75rem center/8px 10px;
}
.disabled-select >>> .vs__dropdown-toggle{
    background: #d1f5ea!important;
    color:#b2b6be!important;
    pointer-events: none;
}
.disabled-select >>> input{
    background: #d1f5ea!important;
    color:#b2b6be!important;
}
.checkmarks{
    position: absolute;
    right: -50px;
    top: 0;
}
.points{
    padding: 5px 30px;
    font-size: 17px;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    max-height: 30px;
    color: #fff;
}
.check{
    border: 1px solid #89cfc0;
    background: #49cda8;
}
.gri{
    border: 1px solid #a4a8ab;
    background: #a4a8ab;
}
.deny{
    border: 1px solid #ff6767;
    background: #ff6767;
}
.checkmarks .check{
    border-radius: 50%;
    color: #49cda8;
    background: transparent;
    border-color: transparent;
}
.checkmarks .deny{
    border-radius: 50%;
    color: #ff6767;
    background: transparent;
    border-color: transparent;
}
.form-group >>> legend{
    text-align: right;
    font-size: 12px !important;
    color: #777e90;
    font-weight: 500;
}
.form-group >>> input, input{
    border-radius: 2px;
    padding: 5px 10px;
    height: inherit;
    font-size: 14px;
    max-height: 30px;
    font-weight: 700;
    color: #767a95;
    background: #e9ecef;
    text-transform: uppercase;
}
.form-group >>> input:read-only{
    background: #a1fff1;
}
.form-group >>> .form-row{
    align-items: flex-start;
}
.has-icon{
    position: relative;
}
.has-icon img{
    position: absolute;
    top: 0;
    bottom: 0;
    right: 7%;
    margin: auto 0;
    opacity: 0.3;
}
.caen-input p{
    text-align: right;
    font-size: 12px !important;
    color: #777e90;
    font-weight: 500;
}
.caen-input >>> label{
    font-size: 12px !important;
    color: #777e90;
    font-weight: 500;
    line-height: 23px;
}
.warn p{
    margin: 0;
    font-size: 12px;
    color: #777e90;
}
.warn p:first-child{
    font-weight: 500;
    font-size: 14px;
}

.switch-box{
    text-align: right;
}
.switch-box >>> label{
    font-size: 14px !important;
    color: #38393c;
    line-height: 1.9 !important;
}
.switch-box >>> input, .switch-box >>> label{
    cursor: pointer;
}
.v-select{
    min-width: 168px;
    max-height: 30px;
}
.v-select >>> .vs__dropdown-menu {
    background: #e9ecef;
    max-height: 200px;
    overflow-y: auto;
}
.min-width >>> legend{
    min-width: 178px;
}
.v-select >>> .vs__dropdown-toggle{
    background: #e9ecef;
    margin: 0;
    border-radius: 3px;
    max-height: 30px;
}
.v-select >>> .vs__dropdown-option {
    color: #767a95;
    font-size: 14px;
    font-weight: 600;
}
.v-select >>> .vs__search{
    margin: 0;
    padding: 0;
}
.v-select >>> .vs__selected{
    color: #767a95;
    font-size: 14px;
    font-weight: 600;
    margin: 0;
}
.caen-name-input{
    width: 47%;
}
@media (max-width: 1700px){
    .white-box{
        padding: 20px 35px;
    }
    .points{
        width: 10%;
        font-size: 15px;
        padding: 5px;
    }
    .checkmarks{
        right: -30px;
    }
}
@media (max-width: 1600px){
    .caen-name-input{
        width: 35% !important;
    }
    .points{
        width: 15%;
    }
}
</style>
